const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

// The backend 422s a non-UUID filter; only send one that would be accepted.
export function isUuid(v: string): boolean {
  return UUID_RE.test(v)
}

export function shortId(id: string): string {
  return id.slice(0, 8)
}
